import { HttpData, HttpNoData } from "./core";

export function checkTokenAsync(token){

    return HttpNoData('/api/auth/v1/auth', 'HEAD', token);
}

export function loginAsync(login, password){

    return HttpData('/api/auth/v1/auth', 'POST', null, {
        login, password
    })
}

export function getPickAsync(token){

    return HttpNoData('/api/auth/v1/picks', 'GET', token);
}